import React, { useContext, useState, useEffect } from 'react';
import classNames from 'classnames';
import { KickCounterContext } from '../../../context/KickCounterContext';
import DebounceButton from '../../button/DebounceButton';
import EndSessionModel from '../../modal/EndSessionModal';
import Modal from '../../modal/Modal';
import TimeReminderModal from '../../modal/TimeReminderModal';
import SessionLog from './SessionLog';
import styles from './SecondaryPanel.module.css';
import useEndSession from '../../../hooks/useEndSession';
import sharedButtonStyles from '../../button/Button.module.css';
import {
  COUNTER_MODE, MAX_TIME, TIME_WARN_1, TIME_WARN_2,
} from '../../../constants/constants';

export default function SecondaryPanel() {
  const [endSessionModalVisible, setEndSessionModalVisible] = useState(false);
  const [timeWarningModalVisible, setTimeWarningModalVisible] = useState(false);
  const [userEndSession, setUserEndSession] = useState(false);
  const [warningTime, setWarningTime] = useState(0);
  const sessionShouldEnd = useEndSession();
  const {
    kickList, time, setCounterActive, counterMode, sessionStartTime,
  } = useContext(KickCounterContext);

  const mql = window.matchMedia('(max-width: 900px)');

  useEffect(() => {
    if (sessionShouldEnd) {
      setCounterActive(false);
      setEndSessionModalVisible(true);
      setTimeWarningModalVisible(false);
    }

    if (time === TIME_WARN_1 && counterMode === COUNTER_MODE.TIME) {
      setWarningTime(MAX_TIME - TIME_WARN_1);
      setTimeWarningModalVisible(true);
    } else if (time === TIME_WARN_2 && counterMode === COUNTER_MODE.TIME) {
      setWarningTime(MAX_TIME - TIME_WARN_2);
      setTimeWarningModalVisible(true);
    }
  }, [time, kickList, sessionShouldEnd]);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.titleContainer}>
        <div>Session Log</div>
      </div>
      <div className={styles.logContainer}>
        <SessionLog />
      </div>
      <div className={styles.bottomContainer}>
        <DebounceButton
          onClick={() => {
            setEndSessionModalVisible(true);
            setUserEndSession(true);
            setCounterActive(false);
          }}
          className={classNames(
            styles.saveButton,
            sharedButtonStyles.FCButtonEnabled,
            sharedButtonStyles.long,
          )}
          disabled={sessionStartTime === null}
        >
          Save this session
        </DebounceButton>
      </div>
      {endSessionModalVisible && (
      <Modal>
        <EndSessionModel userEndSession={userEndSession} />
      </Modal>
      )}
      {timeWarningModalVisible && !mql.matches && (
      <Modal maxWidth={550}>
        <TimeReminderModal
          time={warningTime / 60}
          onCancel={() => setTimeWarningModalVisible(false)}
        />
      </Modal>
      )}
    </div>
  );
}
